
<app-tablelayout [data]="students" [columnsToRemove]="removeColumn" [count]="count" [offset]="offset"
  (loadDataEvent)="loadTableData($event)" [allowMultiSelect]="true" [selectBy]="selectBy" [operation]="operations" 
  (onItemSelected)="itemSelected($event)" (onOperationActionFired)="setBatchId($event)"><app-tablelayout />